import { css, cx } from '@emotion/css'
import { useStats } from '../lib/ctx/stats'
import { CompProps } from '@fable/types'
import { Ref, forwardRef } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  backgroundColor?: string
  empty?: boolean
}

const Content = (
  {
    children,
    backgroundColor,
    empty = false,
    className = '',
    ...props
  }: CompProps<Props>,
  ref: Ref<HTMLDivElement>
) => {
  const theme = useStats((s) => s.theme)
  const bgColor = backgroundColor || theme.bg200

  return (
    <div
      ref={ref}
      className={cx(
        css`
          padding: 16px;
          padding-bottom: ${empty ? '42px' : '16px'};
          background-color: ${bgColor};
          border-radius: 20px;
        `,
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export const StatsContainer = forwardRef(Content)
